export default __webpack_public_path__ + "2a11d87659f3394dbca748926ae24e40.svg";